import { compose } from 'redux';
import { createMaintenanceReducer } from './createMaintenance';
import { deleteMaintenanceReducer } from './deleteMaintenance';
import { fetchMaintenanceByIdReducer } from './fetchMaintenanceById';
import { fetchMaintenanceListReducer } from './fetchMaintenanceList';
import { updateMaintenanceReducer } from './updateMaintenance';

export const extraReducers = compose(
  fetchMaintenanceListReducer,
  fetchMaintenanceByIdReducer,
  createMaintenanceReducer,
  updateMaintenanceReducer,
  deleteMaintenanceReducer,
);

export { createMaintenance } from './createMaintenance';
export { deleteMaintenance } from './deleteMaintenance';
export { fetchMaintenanceById } from './fetchMaintenanceById';
export { fetchMaintenanceList } from './fetchMaintenanceList';
export { updateMaintenance } from './updateMaintenance';
